import { PART_STATUS_FILTERS, PART_STATUS_FILTER_LABEL } from '../types'
import type { PartStatusFilter } from '../types'

export interface StatusFilterBarProps {
  readonly active: PartStatusFilter
  readonly onChange: (filter: PartStatusFilter) => void
}

/**
 * Status-filter chip row (screens.md §5: "search + status-filter chips
 * (All/Ready/Config/Quote/Match)"). Built from native `<input
 * type="radio">`s — one filter is active at a time, a single-select radio
 * semantic — rather than the source prototype's plain, non-interactive
 * `<span>`s; the pill visual comes from the label styling
 * (`.parts-filter-chip`), the input itself is visually hidden but stays in
 * the tab/keyboard-nav path (`.sr-only`, not `display:none`).
 */
export function StatusFilterBar({ active, onChange }: StatusFilterBarProps) {
  return (
    <fieldset className="parts-filter-bar">
      <legend className="sr-only">Filter by status</legend>
      {PART_STATUS_FILTERS.map((filter) => {
        const selected = filter === active
        return (
          <label
            key={filter}
            className={
              selected ? 'parts-filter-chip parts-filter-chip-active' : 'parts-filter-chip'
            }
          >
            <input
              type="radio"
              name="parts-status-filter"
              className="sr-only"
              checked={selected}
              onChange={() => onChange(filter)}
            />
            {PART_STATUS_FILTER_LABEL[filter]}
          </label>
        )
      })}
    </fieldset>
  )
}
